import { CopyOutlineIcon } from '@carboncopyco/icons';
import {
  TextBadge,
  TextCaption,
  TextTooltip,
  Tooltip,
  TooltipBubble,
} from '@carboncopyco/ui';
import { getMaxZIndex } from '@carboncopyco/utils';
import { useHover } from 'ahooks';
import { useRef } from 'react';
import { useCopy } from '../hooks';

const ExampleItem = ({ example }: { example: string }) => {
  const { copyText } = useCopy();
  const anchorRef = useRef<HTMLDivElement>(null);
  const lineRef = useRef<HTMLDivElement>(null);
  const isHovering = useHover(lineRef);

  return (
    <>
      <div
        ref={lineRef}
        key={example.trim()}
        className="flex justify-between h-6 items-center p-2  rounded-md bg-ds-natural-100 group"
      >
        <div className="flex flex-col justify-center max-w-[90%] truncate">
          <TooltipBubble
            title={example}
            placement="top-start"
          >
            <div className="flex  items-center justify-center">
              <TextBadge
                ellipsis
                label={example}
                color="text-ds-natural-300"
              />
            </div>
          </TooltipBubble>
        </div>

        {isHovering && (
          <div
            ref={anchorRef}
            className="hidden items-center h-full cursor-pointer ml-2  group-hover:flex "
            onClick={() => copyText(example)}
          >
            <CopyOutlineIcon size={16} />
          </div>
        )}
      </div>
      <Tooltip
        zIndex={getMaxZIndex() + 1}
        appendTo={() => document.body}
        delay={[700, 0]}
        placement="top"
        anchorRef={anchorRef}
        background="dark"
        shadow="lg"
      >
        <div className="px-1.5 pb-1 pt-0 leading-none break-words max-w-75 whitespace-normal">
          <TextTooltip
            label="Copy to clipboard"
            color="text-ds-natural-50"
          />
        </div>
      </Tooltip>
    </>
  );
};

export const PromptExamples = () => {
  const examples = [
    'Replace names with random French first names',
    'Move dates up by a year',
    'Multiply current values by 3',
  ];

  return (
    <div className="flex flex-col gap-1.5 pt-1">
      <TextCaption
        label="Examples:"
        color="text-ds-natural-600"
      />
      {examples.map((example) => (
        <ExampleItem
          example={example}
          key={example}
        />
      ))}
    </div>
  );
};
